module.exports = __webpack_public_path__ + "static/media/sem_gluten.f9847a7e.png";